const Data = [
  {
    name: "Ankesh Kumar Singh",
    position: "TechOps Head",
    imageUrl: "/assets/images/members/Heads26/AnkeshKumarSingh.jpeg",
    facebookLink: "https://www.facebook.com/profile.php?id=61563457962386",
    email: "ankeshkrsingh0608@gmail.com",
    linkedinLink: "https://www.linkedin.com/in/ankesh-kumar-singh-186323304?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Naunidh Singh Madhok",
    position: "TechOps Head",
    imageUrl: "/assets/images/members/Heads26/NaunidhSinghMadhok.JPG",
    facebookLink: "",
    email: "Naunidhsinghmadhok.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/naunidh-madhok-b6493a193?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
  }
];

export default Data;